<!--suppress HtmlUnknownTag -->
<template>
  <div class="register mt-1">
    <b-container ref="registrationForm">
      <b-row v-if="!isReverseOtp" class="text-center pt-4 pb-1" align-h="center">
        <b-col>
          <img class="logo" src="@/assets/img/logo.png" alt="">
          <h2 v-if="!referUser">{{ $t("AUTH.GET_STARTED") }}</h2>
          <b-col v-if="referUser">
            <h2>{{ referUser }} {{ $t("REFERRAL.REFERRAL_JUST_GIFTED") }}</h2>
            <p style="font-size: 22px; margin-top: 10px; color: var(--primary-color);">{{
              ownedProperties ? $t("REFERRAL.REFERRAL_OWN_PROPERTIES", {
                name: referUser,
                bonus_text: referBonusText,
                bonus_required_text: referBonusRequiredText,
              }) :
                $t("REFERRAL.JOIN_GORO_TO_START_INVESTING")
              }}</p>
          </b-col>
          <b-row v-if="referUser" align-h="center" class="mt-1 mb-2">
            <img class="property-image" v-for="image in propertyImages" :src="getUrlImage(image)" alt="">
          </b-row>
          <p>{{ $t("REFERRAL.REFERRAL_SIGN_UP_TO_INVEST") }}</p>
        </b-col>
      </b-row>
      <b-row class="justify-content-center align-items-center">
        <Form v-if="!isInputOtp && !isReverseOtp" class="form col-md-5" v-slot="{ errors, handleSubmit }">
          <b-form @submit.prevent="handleSubmit(requestOtp)">
            <p v-if="!isRegisterWithSocmed" class="text-center pt-1 pb-1">{{ $t("AUTH.REGISTER_WITH") }}</p>
            <div v-if="!isRegisterWithSocmed">
              <b-button id="btn_RegisterWithGoogle" class="btn-outline-main col-12 my-1 py-2"
                variant="none" @click.prevent="getGoogleUserInfo">
                <img width="16" height="16" class="mb-1 mr-1" src="@/assets/img/socials/google_auth.svg" alt="" />
                {{ $t("AUTH.GOOGLE") }}
              </b-button>
              <b-button id="btn_RegisterWithFacebook" class="btn-outline-main col-12 mt-2 mb-1 py-2"
                variant="none" @click.prevent="getFacebookUserInfo">
                <img width="16" height="16" class="mb-1 mr-1" src="@/assets/img/socials/facebook_auth.svg" alt="" />
                {{ $t("AUTH.FACEBOOK") }}
              </b-button>
              <b-button id="btn_RegisterWithApple" class="btn-outline-main col-12 mt-2 py-2" variant="none"
                @click.prevent="registerWithApple">
                <img width="16" height="16" class="mb-1 mr-1" src="@/assets/img/socials/apple_auth.svg" alt="" />
                {{ $t("AUTH.APPLE") }}
              </b-button>
            </div>
            <hr v-if="!isRegisterWithSocmed" class="solid">
            <p v-if="!isRegisterWithSocmed" class="text-center">{{ $t("AUTH.OR_FILL_IN_THIS_FORM") }}</p>
            <div v-if="isRegisterWithSocmed">
              <b-icon class="click-able float-right" icon="x" style="color: #6C757D;" scale="1.5"
                @click.prevent="clearSocmedInfo" />
              <p class="pb-2 text-center" style="color: #6C757D;">
                {{ $t("AUTH.COMPLETE_YOUR_PROFILE") }}</p>
            </div>

            <Field :model-value="form.name" @update:modelValue="form.name = $event" :name="$t('AUTH.FULL_NAME')"
              :rules="{ required: true, min: 2, legal_name: [{ ...form }] }" v-slot="context">
              <b-form-group :label="$t('AUTH.FULL_NAME')">
                <b-form-input v-bind="context.field" placeholder="John Doe" aria-describedby="input-name-feedback"
                  :state="getValidationState(context.meta)"></b-form-input>
                <b-form-invalid-feedback id="input-name-feedback">
                  {{ errors[$t("AUTH.FULL_NAME")] }}
                </b-form-invalid-feedback>
                <p class="name-note">{{ $t("AUTH.REGISTER_NAME_NOTE") }}</p>
              </b-form-group>
            </Field>

            <Field :model-value="form.email" @update:modelValue="form.email = $event" :name="$t('AUTH.EMAIL')"
              :rules="{ required: true, email: true }" v-slot="context">
              <b-form-group :label="$t('AUTH.EMAIL')">
                <b-form-input v-bind="context.field" placeholder="someone@example.com" type="email"
                  :disabled="isRegisterWithFacebook || isRegisterWithGoogle" :state="getValidationState(context.meta)"
                  aria-describedby="input-email-feedback"></b-form-input>
                <b-form-invalid-feedback id="input-email-feedback">
                  {{ errors[$t('AUTH.EMAIL')] }}
                </b-form-invalid-feedback>
                <div v-if="autocorrectEmail" class="suggested-email">
                  <p class="prompt">{{ $t("AUTH.EMAIL_CORRECTION") }} <a class="suggestion"
                      @click="useEmailSuggestion">{{
                      autocorrectEmail }}</a>?</p>
                </div>
              </b-form-group>
            </Field>

            <Field :name="$t('AUTH.PHONE')" :rules="{}" v-slot="{ valid, errors, field }">
              <legend>{{ $t("AUTH.PHONE") }}</legend>
              <vue-tel-input v-bind="field" v-model="vuePhone.phone" @on-input="updatePhoneNumber"
                :validCharactersOnly="false"
                :dropdownOptions="{ showDialCodeInList: true, showDialCodeInSelection: true, showFlags: true, showSearchBox: true, searchBoxPlaceholder: $t('AUTH.TEL_INPUT_SEARCH_PLACEHOLDER') }"
                :inputOptions="{ autocomplete: false, name: 'phone', placeholder: $t('AUTH.ENTER_YOUR_PHONE_NUMBER') }"
                defaultCountry="ID" :preferredCountries="['ID']"></vue-tel-input>

              <label class="invalid" v-if="!vuePhone.isValid">
                {{ errors[$t('AUTH.PHONE')] || vuePhone.isEmpty ? $t('AUTH.THE_PHONE_IS_REQUIRED') :
                  $t('AUTH.INVALID_PHONE_NUMBER') }}</label>
            </Field>

            <div v-if="!isRegisterWithSocmed">
              <Field vid="password" :name="$t('AUTH.PASSWORD')"
                :rules="{ required: true, min: 8, strong_password_user_info: [{ ...form, nationalNumber: tmpFormData.phone.nationalNumber }], strong_password_criteria: [{ ...form, nationalNumber: tmpFormData.phone.nationalNumber }] }"
                v-slot="context" :model-value="form.password" @update:modelValue="form.password = $event">
                <b-form-group class="mt-3" :label="$t('AUTH.PASSWORD')">
                  <b-input-group>
                    <b-form-input v-bind="context.field" placeholder="••••••••••••"
                      :type="showPassword ? 'text' : 'password'" aria-describedby="input-password-feedback"
                      :state="getValidationState(context.meta)"></b-form-input>
                    <b-input-group-append>
                      <div class="show-hide d-flex justify-content-center align-items-center"
                        @click="showPassword = !showPassword">
                        <b-icon width="18" height="18" color="white"
                          :icon="showPassword ? 'eye' : 'eye-slash'"></b-icon>
                      </div>
                    </b-input-group-append>
                    <b-form-invalid-feedback id="input-password-feedback">
                      {{ errors[$t('AUTH.PASSWORD')] }}
                    </b-form-invalid-feedback>
                  </b-input-group>
                  <ul class="goro-password-strength-checklist">
                    <li :style="getPasswordIconStyle(passwordLeast8Length)">
                      <b-icon :icon="getPasswordIcon(passwordLeast8Length)"
                        :style="getPasswordIconStyle(passwordLeast8Length)" scale="1.4"></b-icon>
                      <span class="font-14">{{ $t("CHANGE_PASSWORD.CHECKLISTS.LEAST1CHAR") }}</span>
                    </li>
                    <li :style="getPasswordIconStyle(passwordLeast1Number)">
                      <b-icon :icon="getPasswordIcon(passwordLeast1Number)"
                        :style="getPasswordIconStyle(passwordLeast1Number)" scale="1.4"></b-icon>
                      <span class="font-14">{{ $t("CHANGE_PASSWORD.CHECKLISTS.LEAST1NUMBER") }}</span>
                    </li>
                    <li :style="getPasswordIconStyle(passwordLeast1Upper1LowerCase)">
                      <b-icon :icon="getPasswordIcon(passwordLeast1Upper1LowerCase)"
                        :style="getPasswordIconStyle(passwordLeast1Upper1LowerCase)" scale="1.4"></b-icon>
                      <span class="font-14">{{ $t("CHANGE_PASSWORD.CHECKLISTS.LEAST1CHARCASE") }}</span>
                    </li>
                    <li :style="getPasswordIconStyle(passwordLeast1Special)">
                      <b-icon :icon="getPasswordIcon(passwordLeast1Special)"
                        :style="getPasswordIconStyle(passwordLeast1Special)" scale="1.4"></b-icon>
                      <span class="font-14">{{ $t("CHANGE_PASSWORD.CHECKLISTS.LEAST1SPECIAL") }}</span>
                    </li>
                  </ul>
                </b-form-group>
              </Field>
            </div>

            <b-form-group :label="$t('REFERRAL.REFERRAL_CODE')">
              <b-form-input name="referral_code" placeholder="123456ABC" :disabled="disabledReferralInput"
                v-model="form.referral_code"></b-form-input>
            </b-form-group>

            <Field :name="$t('AUTH.I_ACCEPT_TERMS_AND_PRIVACY')" :rules="{ required: { allowFalse: false } }"
              v-slot="{ valid, errors, field, meta, handleChange }" :model-value="form.accept_status"
              @update:modelValue="form.accept_status = $event">
              <div class="d-flex flex-row align-items-center">
                <b-form-checkbox @change="handleChange" class="pt-1" name="accept_status"
                  style="font-weight: 400; font-size: 16px; z-index: 0" :state="getValidationState(meta)">
                </b-form-checkbox>
                <p :style="getTCStyle(meta)" style="margin-top: 2px;">{{
                  $t('AUTH.I_ACCEPT_THE') }} <span @click="openTC" class="font-bold" style="cursor: pointer;">{{
                    $t('FOOTER.TERMS_AND_CONDITIONS') }}</span> & <span @click="openPrivacyPolicy" class="font-bold"
                    style="cursor: pointer;">{{ $t('FOOTER.PRIVACY_POLICY')
                    }}</span></p>
              </div>
            </Field>

            <b-col class="text-center pt-4" align-h="center">
              <p class="font-bold mb-2" style="color: dodgerblue; font-size: 12px" v-if="isOtpTypeWaba">
                {{ $t("AUTH.OTP_NOTICE") }}
              </p>
              <b-button id="btn_ManualRegister" class="btn-main pl-4 pr-4" type="submit" variant="none">
                {{ $t("AUTH.REGISTER") }}
              </b-button>
            </b-col>
          </b-form>
        </Form>

        <b-form v-if="isInputOtp" class="form text-center" style="width: 510px" @submit.prevent="register">
          <p class="font-bold font-32 pb-1" style="color: var(--primary-color)">
            {{ $t("AUTH.VERIFICATION") }}
          </p>
          <p class="font-bold pl-5 pr-5" style="color: #989898; font-size: 14px">
            {{ $t("AUTH.ENTER_THE_OTP") }}
          </p>
          <p class="font-bold font-26 color-gray-6d pt-3" style="margin-bottom: -6px">
            {{ form.phone }}
          </p>
          <label class="hyperlink font-bold font-14 pb-1" @click="changePhoneNumber">
            <u>{{ $t("AUTH.CHANGE_PHONE_NUMBER") }}</u>
          </label>
          <label class="invalid font-bold pb-2"
            :style="{ visibility: !isInputOtpValid && observeInputOtp ? 'visible' : 'hidden' }">
            {{ $t("AUTH.OTP_REQUIRED") }}
          </label>
          <div style="display: flex; justify-content: center; align-items: center;">
            <v-otp-input ref="otpInput" v-model:value="form.otp_code" input-classes="otp-input" separator=" "
              :num-inputs="6" :should-auto-focus="true" input-type="numeric" @on-change="onInputOtpChange" />
          </div>
          <b-col class="text-center pt-3" align-h="center">
            <b-row class="align-items-center" align-h="center" v-if="isOtpTypeWaba && inputOtpStatus">
              <p class="font-bold font-14 color-gray-6d">{{ $t("AUTH.OTP_DELIVERY_STATUS") }}</p>
              <p class="font-bold font-14 text-white ml-2" :class="otpStatusClass">{{ otpStatusText }}</p>
            </b-row>
            <b-row class="otp-notice-background">
              <p class="font-bold font-12" v-if="isOtpTypeWaba">
                {{ $t("AUTH.OTP_NOTICE") }}
              </p>
            </b-row>
            <b-button id="btn_Register_VerifyOtp" class="btn-main mt-1 pt-2 pb-2" type="submit" variant="none"
              style="width: 350px">
              {{ $t("AUTH.VERIFY") }}
            </b-button>
          </b-col>
          <b-row class="flex text-center pt-2 pb-2" align-h="center">
            <p class="font-bold color-gray-6d font-14">{{ $t("AUTH.OTP_DID_NOT_RECEIVE") }}</p>
            <p class="font-bold font-14 ml-1" :class="otpResendClass" @click="requestOtp">
              {{ resendOtpText }}
            </p>
          </b-row>
        </b-form>

        <b-col v-if="isReverseOtpStep1" class="text-center pt-2 mb-4" cols="auto">
          <img width="300" class="mt-5 mb-5"
               src="@/assets/img/registration/otp_reverse_send.svg" alt="" @click="onRequestInputOtpClicked"/>
          <b-form class="form reverse-otp-form text-center" @submit.prevent="openWhatsappToSendReverseOtp">
            <p class="font-bold" style="font-size:26px; color: var(--text-color-darker)">
              {{ $t("AUTH.VERIFY_ACCOUNT_VIA_WHATSAPP") }}
            </p>
            <p class="font-normal mt-2 mb-3" style="color: var(--text-color-darker)">
              {{ $t("AUTH.VERIFY_ACCOUNT_VIA_WHATSAPP_DESCRIPTION") }}
            </p>
            <div class="reverse-otp-warning d-flex align-items-center px-2 py-2 mt-3 mb-3">
              <img src="@/assets/img/registration/warning.svg" alt="Warning" class="ml-1 mr-2"/>
              <p class="font-wide-bold text-center flex-grow-1" style="color: var(--text-color-warning); font-size: 14px">
                {{ $t("AUTH.VERIFY_ACCOUNT_VIA_WHATSAPP_WARNING") }}
              </p>
            </div>
            <b-button class="btn-main mt-1 pt-2 pb-2" type="submit" variant="none" style="font-size: 18px; width: 100%">
              {{ $t("AUTH.SEND_VERIFICATION_VIA_WHATSAPP") }}
            </b-button>
          </b-form>
        </b-col>

        <b-col v-if="isReverseOtpStep2" class="text-center pt-2" cols="auto">
          <img width="300" class="mt-5 mb-5"
               src="@/assets/img/registration/otp_reverse_verifying.svg" alt="" @click="onRequestInputOtpClicked"/>
          <b-form class="form reverse-otp-form text-center" @submit.prevent="checkReverseOtpStatus(true)">
            <p class="font-bold" style="font-size:26px; color: var(--text-color-darker)">
              {{ $t("AUTH.VERIFYING_YOUR_CODE") }}
            </p>
            <p class="font-normal mt-2 mb-3" style="color: var(--text-color-darker); white-space: pre-wrap;">
              {{ $t("AUTH.VERIFYING_YOUR_CODE_DESCRIPTION") }}
            </p>
            <div class="reverse-otp-warning d-flex align-items-center px-2 py-2 mt-3 mb-3">
              <img src="@/assets/img/registration/warning.svg" alt="Warning" class="ml-1 mr-2"/>
              <p class="font-wide-bold text-center flex-grow-1" style="color: var(--text-color-warning); font-size: 14px">
                {{ $t("AUTH.VERIFY_ACCOUNT_VIA_WHATSAPP_WARNING") }}
              </p>
            </div>
            <b-button class="btn-main mt-1 pt-2 pb-2" type="submit" variant="none" style="font-size: 18px; width: 100%">
              {{ $t("AUTH.CHECK_VERIFICATION_STATUS") }}
            </b-button>
            <p class="font-bolder mt-3" style="color: var(--text-color-darker);">
              {{ $t("AUTH.VERIFYING_YOUR_CODE_WARNING") }}
            </p>
            <b-row class="flex text-center" align-h="center">
              <p class="font-normal" style="font-size: 15px; color: var(--text-color-darker);">
                {{ $t("AUTH.OTP_DID_NOT_RECEIVE") }}</p>
              <p class="font-normal ml-1" :class="otpResendClass" @click="requestOtp">
                {{ resendOtpText }}
              </p>
            </b-row>
          </b-form>
          <b-row align-h="center">
            <p class="reverse-otp-warning text-center font-normal px-3 py-2 mt-4 mb-1"
               style="color: var(--text-color-darker); font-size: 16px" v-html="needHelpText"/>
          </b-row>
        </b-col>
      </b-row>

      <b-row v-if="!isReverseOtp" align-h="center">
        <router-link :to="{ name: 'login' }">
          <p class="text-center pt-3" style="font-weight: 600">
            {{ $t("AUTH.ALREADY_HAVE_AN_ACCOUNT") }}
            <span style="color: var(--primary-color); font-weight: 600">{{ $t("AUTH.LOGIN") }}</span>
          </p>
        </router-link>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {configure, defineRule, Field, Form} from "vee-validate"
import {email, min, regex, required} from "@vee-validate/rules"
import {localize, setLocale} from "@vee-validate/i18n"
import {facebookAuth} from "../../helpers/facebookAuth"
import authService from "../../services/auth.service"
import commonService from "../../services/common.service"
import VOtpInput from "vue3-otp-input"
import {
  clearStorageActionKeys,
  exchange,
  getCookie,
  getDeviceInfo,
  getDeviceUUID,
  getErrorMessage,
  notify,
  urlImage
} from "../../helpers/common"
import messErrors from "../../constants/errors"
import store from "../../store/store"
import {FOREIGNER, INDO, OTP_METHOD, OTP_STATUS, OTP_TYPE, REGEX, STATUS_CODE} from "../../constants/constants"
import {gtmTrackEvent} from "../../helpers/gtm"
import {GTM_EVENT_NAMES} from "../../constants/gtm"
import {FIREBASE_EVENTS, firebaseLogEvent} from "../../helpers/firebase";
import {requestSignIn} from "../../helpers/appleAuth"
import externalSites from "@/constants/externalSites";

let DEFAULT_RESEND_OTP_TIME_IN_SECONDS = 120
defineRule("email", email)
defineRule("min", min)
defineRule("required", required)
defineRule('regex', regex)

/**
 * Not based on something that is easy to guess or uses information related to the User, for example: name, telephone number, date of birth
 */
defineRule('strong_password_user_info', (value, [otherValues]) => {
  let { nationalNumber, name, email } = otherValues

  if (!name) {
    name = ''
  }
  name = name.split(' ').join('').trim()

  if (name && value.toLowerCase().includes(name.toLowerCase())) {
    return false
  }

  if (nationalNumber && value.includes(nationalNumber)) {
    return false
  }

  if (email && value.includes(email)) {
    return false
  }

  return true
})

/**
 * Uses a combination of uppercase letters, lowercase letters and numbers, wherever possible using special characters (such as: !$%#*)
 */
defineRule('strong_password_criteria', (value, [otherValues]) => {
  // Check if the password contains a combination of uppercase, lowercase, numbers, and special characters
  const regexPattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^A-Za-z0-9])[A-Za-z0-9!@#$%^&*()_+{}\[\]:;<>,.?/~\-\\]+$/
  if (!regexPattern.test(value)) {
    return false
  }

  return true
})

defineRule("legal_name", (value, [otherValues]) => {
  // Check if the password contains a combination of uppercase, lowercase, numbers, and special characters
  if (!REGEX.LEGAL_NAME.test(value)) {
    return false
  }

  return true
})

configure({
  generateMessage: localize({
    en: {
      messages: {
        required: 'The {field} is required',
        legal_name: 'Legal name only accepts alphabets, single quotes, commas, full stops, and single spaces.',
        strong_password_user_info: 'Password cannot contain user-related information.',
        strong_password_criteria: 'Password should contain a mix of uppercase letters, lowercase letters, numbers, and special characters.',
      },
    },
    id: {
      messages: {
        required: 'Kolom {field} wajib diisi',
        legal_name: 'Nama resmi hanya menerima alfabet, tanda kutip tunggal, koma, titik, dan satu spasi.',
        strong_password_user_info: 'Kata sandi tidak boleh mengandung informasi yang berhubungan dengan pengguna.',
        strong_password_criteria: 'Kata sandi harus mengandung kombinasi huruf kapital, huruf kecil, angka, dan karakter khusus.',
      },
    },
  }),
})

export default {
  components: {
    Form, Field, VOtpInput
  },

  data () {
    return {
      title: "Register",
      form: {
        "platform": "web",
        "uuid": getDeviceUUID(),
        "cookie_fbp": getCookie("_fbp"),
      },
      referUser: "",
      refereeBonusPercent: null,
      tmpFormData: {
        phone: {
          nationalNumber: null,
        },
      },
      vuePhone: {
        phone: "",
        isValid: true,
        isEmpty: true,
        props: {
          error: true,
          clearable: true,
          //fetchCountry: true, //Do not use it with defaultCountryCode
          defaultCountryCode: "ID",
          preferredCountries: ["ID"],
          translations: {
            countrySelectorLabel: this.$t("AUTH.COUNTRY_CODE"),
            phoneNumberLabel: this.$t("AUTH.PHONE_HINT"),
            example: this.$t("common.example"),
          },
          color: "#80BDFF",
          validColor: "#006666",
          errorColor: "#DC3445",
        }
      },
      oldPhone: null,
      resendOtpTimer: 0,
      isReverseOtpStep1: false,
      isReverseOtpStep2: false,
      isReversedOtpVerified: false,
      reverseOtpMessageTo: "",
      reverseOtpMessageContent: "",
      requestInputOtpClickCount: 0,
      isInputOtp: false,
      isInputOtpValid: false,
      observeInputOtp: false,
      inputOtpStatus: OTP_STATUS.QUEUED,
      getInputOtpStatusInterval: null,
      showPassword: false,
      propertyImages: [],
      ownedProperties: true,
      autocorrectEmail: "",
      deviceInfo: getDeviceInfo(),
    }
  },
  async mounted() {
    //load social login data to form then clear it from store
    this.form = {
      "google_id": this.$store.getters.socialLoginData.google_id,
      "google_token": this.$store.getters.socialLoginData.google_token,
      "email_google": this.$store.getters.socialLoginData.email_google,
      "fb_id": this.$store.getters.socialLoginData.fb_id,
      "fb_token": this.$store.getters.socialLoginData.fb_token,
      "email_fb": this.$store.getters.socialLoginData.email_fb,
      "email": this.$store.getters.socialLoginData.email,
      "apple_id": this.$store.getters.socialLoginData.apple_id,
      "apple_token": this.$store.getters.socialLoginData.apple_token,
      "email_apple": this.$store.getters.socialLoginData.email_apple,
      "grant_type": this.$store.getters.socialLoginData.grant_type,
      "platform": "web",
    }
    await store.dispatch("setSocialLoginData", {})
    setLocale(this.$i18n.locale)
    await facebookAuth.init()
  },

  async created() {
    await this.getReferralInviter()
  },

  async beforeDestroy() {
    this.stopGetInputOtpStatus()
    this.stopCheckReverseOtpStatus()
  },

  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    updatePhoneNumber(number, data) {
      if (number) {
        this.vuePhone.isValid = data.valid
        this.vuePhone.isEmpty = false
      } else {
        this.vuePhone.isEmpty = true
      }
      this.form.phone = data.number
      this.form.country_code = data.countryCallingCode
      this.form.iso_country_code = data.countryCode
      this.tmpFormData.phone.nationalNumber = data.nationalNumber
    },
    async getFacebookUserInfo() {
      let loginResponse = await facebookAuth.login(
        { scope: "email, public_profile", return_scopes: true, auth_type: "rerequest" })
      if (loginResponse && loginResponse.authResponse) {
        let authResponse = loginResponse.authResponse
        let userResponse = await facebookAuth.api("/me", { fields: "email, name" })
        if (userResponse) {
          try {
            await this.$recaptchaLoaded()
            const recaptchaToken = await this.$recaptcha("loginWithFacebook")
            const data = await authService.loginWithFacebook({
              "fb_id": authResponse.userID,
              "fb_token": authResponse.accessToken,
              "email_fb": userResponse.email,
              "uuid": getDeviceUUID(),
              "cookie_fbp": getCookie("_fbp"),
              "recaptcha_token": recaptchaToken,
              ...this.deviceInfo,
            }, false, true)
            if (data && data.user && data.access_token) {
              await this.onRegisterSuccess(data.user, data.access_token)
            }
          } catch (e) {
            //Login failed -> continue register
            this.vuePhone.phone = ""
            this.form = {
              "fb_id": authResponse.userID,
              "fb_token": authResponse.accessToken,
              "email_fb": userResponse.email,
              "email": userResponse.email,
              "platform": "web"
            }
            if (this.referUser != null && this.referUser !== "" && this.referralCode) {
              this.form.referral_code = this.referralCode
            }
          }
        } else {
          notify({ text: "Facebook: failed to get user info", type: "error" })
        }
      } else {
        notify({ text: "Facebook: login failed.", type: "error" })
      }
    },
    async getGoogleUserInfo() {
      let googleUserInfo = await this.$gAuth.signIn().catch(error => {
        notify({ text: JSON.stringify(error), type: "error" })
      })
      //console.log(googleUserInfo)
      if (googleUserInfo) {
        try {
          await this.$recaptchaLoaded()
          const recaptchaToken = await this.$recaptcha("loginWithGoogle")
          const data = await authService.loginWithGoogle({
            "google_id": googleUserInfo.google_id,
            "google_token": googleUserInfo.google_token,
            "email_google": googleUserInfo.email,
            "uuid": getDeviceUUID(),
            "cookie_fbp": getCookie("_fbp"),
            "recaptcha_token": recaptchaToken,
            ...this.deviceInfo,
          }, false, true)
          if (data && data.user && data.access_token) {
            await this.onRegisterSuccess(data.user, data.access_token)
          }
        } catch (e) {
          this.vuePhone.phone = ""
          this.form = {
            "google_id": googleUserInfo.google_id,
            "google_token": googleUserInfo.google_token,
            "email_google": googleUserInfo.email,
            "email": googleUserInfo.email,
            "platform": "web",
          }
          if (this.referUser != null && this.referUser !== "" && this.referralCode) {
            this.form.referral_code = this.referralCode
          }
        }
      }
    },
    async registerWithApple() {
      requestSignIn((event) => {
        if (event.data) {
          this.syncAppleAccount(event.data)
        }
      })
    },
    async syncAppleAccount(loginData) {
      if (loginData.code && loginData.id && loginData.name && loginData.email) {
        try {
          await this.$recaptchaLoaded()
          const recaptchaToken = await this.$recaptcha("syncAppleAccount")
          const data = await authService.syncAppleAccount({
            apple_id: loginData.id,
            apple_token: loginData.code,
            email_apple: loginData.email,
            uuid: getDeviceUUID(),
            grant_type: "authorization_code",
            recaptcha_token: recaptchaToken,
            ...this.deviceInfo,
          })
          if (data && data.user && data.access_token) {
            await this.onRegisterSuccess(data.user, data.access_token)
          }
        } catch (e) {
          if (e.statusCode === STATUS_CODE.HTTP_NOT_FOUND) {
            if (e.extraData && e.extraData.refresh_token) {
              this.form = {
                "apple_id": loginData.id,
                "apple_token": e.extraData.refresh_token,
                "email": loginData.email,
                "email_apple": loginData.email,
                "grant_type": "refresh_token",
                "platform": "web",
              }
            }
          } else {
            const mess = getErrorMessage(e)
            notify({
              text: mess || messErrors.INTERNAL,
              type: "error"
            })
          }
        }
      }
    },
    async clearSocmedInfo() {
      await store.dispatch("setSocialLoginData", {})
      this.vuePhone.phone = ""
      this.form = { "platform": "web" }
      if (this.referUser != null && this.referUser !== "" && this.referralCode) {
        this.form.referral_code = this.referralCode
      }
    },
    async changePhoneNumber() {
      this.isInputOtp = false
      this.isReverseOtpStep1 = false
      this.isReverseOtpStep2 = false

      this.resendOtpTimer = 0
      this.observeInputOtp = false
      this.inputOtpStatus = OTP_STATUS.QUEUED
      this.stopGetInputOtpStatus()
      this.stopCheckReverseOtpStatus()
    },
    async useEmailSuggestion() {
      this.form.email = this.autocorrectEmail
      this.autocorrectEmail = ""
      await this.requestOtp()
    },
    async requestOtp() {
      let isResend = this.oldPhone != null;
      if (isResend && this.resendOtpTimer > 0) {
        return
      }
      if (this.vuePhone.isValid) {
        gtmTrackEvent({
          event: GTM_EVENT_NAMES.USER_REQUEST_OTP,
        })
        try {
          await this.$recaptchaLoaded()
          const recaptchaToken = await this.$recaptcha("requestOtp")
          let payload = {
            recaptcha_token: recaptchaToken,
            preferred_locale: this.$i18n.locale === FOREIGNER.LOCALE ? "en" : this.$i18n.locale,
            ...this.form
          }
          if (isResend) {
            payload.is_resend = true;
          }
          let data = await authService.requestOtp(payload, true)
          if (data && data.extraData && data.extraData.autocorrect) {
            this.autocorrectEmail = data.extraData.autocorrect
          }
          this.handleOtpResponse(data)
        } catch (ex) {
          const errorMessage = getErrorMessage(ex) || messErrors.INTERNAL;
          notify({ text: errorMessage, type: "error" })
          firebaseLogEvent(FIREBASE_EVENTS.REGISTRATION_FAILED, {
            email: this.form.email,
            phone: this.form.phone,
            method: "RequestOtp",
            error: errorMessage
          });
        }
      }
    },
    displayInputOtp() {
      this.isInputOtp = true
      this.isReverseOtpStep1 = false
      this.isReverseOtpStep2 = false
      this.startGetInputOtpStatus();
      if (this.$refs.registrationForm) {
        this.$refs.registrationForm.scrollIntoView({ behavior: "smooth", block: "start" })
      }
    },
    onInputOtpChange(value) {
      this.isInputOtpValid = value.toString().trim().length === 6
    },
    async getInputOtpStatus() {
      if (this.inputOtpStatus !== OTP_STATUS.DELIVERED && this.inputOtpStatus !== OTP_STATUS.ERROR) {
        let data = await authService.getOtpStatus({
          email: this.form.email,
          phone: this.form.phone,
        })
        if (data && data.status) {
          this.inputOtpStatus = data.status
        }
      } else {
        this.stopGetInputOtpStatus()
      }
    },
    startGetInputOtpStatus () {
      this.stopGetInputOtpStatus()
      this.getInputOtpStatusInterval = setInterval(this.getInputOtpStatus, 6000)
    },
    stopGetInputOtpStatus () {
      if (this.getInputOtpStatusInterval) {
        clearInterval(this.getInputOtpStatusInterval)
      }
    },
    onRequestInputOtpClicked () {
      this.requestInputOtpClickCount++;
      if (this.requestInputOtpClickCount === 12) {
        this.requestInputOtpMethod();
        this.requestInputOtpClickCount = 0;
      }
    },
    async requestInputOtpMethod () {
      const recaptchaToken = await this.$recaptcha('requestInputOtpMethod')
      let data = await authService.requestInputOtpMethod({
        phone: this.form.phone,
        recaptcha_token: recaptchaToken
      })
      this.handleOtpResponse(data)
    },
    handleOtpResponse (data) {
      if (data && data.otp_method) {
        if (data.otp_method === OTP_METHOD.REVERSE_OTP) {
          this.reverseOtpMessageTo = data.message_to
          this.reverseOtpMessageContent = data.message_content
          this.displayReverseOtpStep1()
        } else if (data.otp_method === OTP_METHOD.INPUT_OTP) {
          this.displayInputOtp()
        }
        this.oldPhone = this.form.phone;
        this.resendOtpTimer = store.state.configs?.otp_retry_time != null
          ? store.state.configs.otp_retry_time * 60 : DEFAULT_RESEND_OTP_TIME_IN_SECONDS
      }
    },
    displayReverseOtpStep1 () {
      this.isInputOtp = false
      this.isReverseOtpStep1 = true
      this.isReverseOtpStep2 = false
      if (this.$refs.registrationForm) {
        this.$refs.registrationForm.scrollIntoView({ behavior: "smooth", block: "start" })
      }
    },
    openWhatsappToSendReverseOtp () {
      if (this.reverseOtpMessageTo && this.reverseOtpMessageContent) {
        const phone = this.reverseOtpMessageTo;
        const message = encodeURIComponent(this.reverseOtpMessageContent);
        const url = `https://wa.me/${phone}?text=${message}`;
        window.open(url, '_blank');
        this.displayReverseOtpStep2()
      } else {
        notify({
          text: "Missing reverse OTP info. Please try again or email hello@goro.id for assistance.",
          type: "error"
        })
      }
    },
    displayReverseOtpStep2 () {
      this.isInputOtp = false
      this.isReverseOtpStep1 = false
      this.isReverseOtpStep2 = true
      this.startCheckReverseOtpStatus()
      if (this.$refs.registrationForm) {
        this.$refs.registrationForm.scrollIntoView({ behavior: "smooth", block: "start" })
      }
    },
    async checkReverseOtpStatus (isUserRequest = false) {
      const recaptchaToken = await this.$recaptcha('phoneVerificationStatus')
      let data = await authService.getReverseOtpStatus({
        phone: this.form.phone,
        recaptcha_token: recaptchaToken
      })
      if (data) {
        if (data.is_verified) {
          this.isReversedOtpVerified = true
          this.stopCheckReverseOtpStatus();
          await this.register()
        } else {
          if (isUserRequest) {
            //Notify to user

          }
        }
      }
    },
    startCheckReverseOtpStatus () {
      this.stopCheckReverseOtpStatus()
      this.checkReverseOtpStatusInterval = setInterval(this.checkReverseOtpStatus, 6000)
    },
    stopCheckReverseOtpStatus () {
      if (this.checkReverseOtpStatusInterval) {
        clearInterval(this.checkReverseOtpStatusInterval)
      }
    },
    async register() {
      this.observeInputOtp = true
      if ((this.isReverseOtp && this.isReversedOtpVerified)
        || (this.isInputOtp && this.vuePhone.isValid && this.isInputOtpValid)) {
        await this.$recaptchaLoaded()
        let action = "register"
        if (this.isRegisterWithFacebook) {
          action = "registerWithFacebook"
        } else if (this.isRegisterWithGoogle) {
          action = "registerWithGoogle"
        } else if (this.isRegisterWithApple) {
          action = "registerWithApple"
        }
        const recaptchaToken = await this.$recaptcha(action)
        let gassVid;
        if (this.$route.query.vid) {
          gassVid = this.$route.query.vid.replace(/\D/g, '')
        }
        const formData = {
          ...this.form,
          preferred_locale: this.$i18n.locale === FOREIGNER.LOCALE ? "en" : this.$i18n.locale,
          uuid: getDeviceUUID(),
          cookie_fbp: getCookie("_fbp"),
          recaptcha_token: recaptchaToken,
          user_locale: window.navigator.language,
          gass_vid: gassVid,
          ...this.deviceInfo,
        }
        let data
        let method = ""
        try {
          if (this.isRegisterWithFacebook) {
            method = "Facebook"
            gtmTrackEvent({
              event: GTM_EVENT_NAMES.USER_REGISTER,
              method: method,
            })
            data = await authService.registerWithFacebook(formData)
          } else if (this.isRegisterWithGoogle) {
            method = "Google"
            gtmTrackEvent({
              event: GTM_EVENT_NAMES.USER_REGISTER,
              method: method,
            })
            data = await authService.registerWithGoogle(formData)
          } else if (this.isRegisterWithApple) {
            method = "Apple"
            gtmTrackEvent({
              event: GTM_EVENT_NAMES.USER_REGISTER,
              method: method,
            })
            data = await authService.registerWithApple(formData)
          } else {
            method = "Manual"
            gtmTrackEvent({
              event: GTM_EVENT_NAMES.USER_REGISTER,
              method: method,
            })
            data = await authService.register(formData)
          }
        } catch (e) {
          const errorMessage = getErrorMessage(e) || messErrors.INTERNAL;
          firebaseLogEvent(FIREBASE_EVENTS.REGISTRATION_FAILED, {
            email: this.form.email,
            phone: this.form.phone,
            method: method,
            error: errorMessage
          });
          throw e
        }
        //check registration result
        if (data && data.user && data.access_token) {
          await this.onRegisterSuccess(data.user, data.access_token)
        }
      }
    },
    async onRegisterSuccess(user, accessToken) {
      if (user && accessToken) {
        this.stopGetInputOtpStatus()
        this.stopCheckReverseOtpStatus()
        clearStorageActionKeys()
        localStorage.setItem("Authorization", accessToken)

        await store.dispatch("setShowRegistrationComplete", true)

        await store.dispatch("setUserProfile", user)
        await store.dispatch("getDocumentVersioning")

        gtmTrackEvent({
          event: GTM_EVENT_NAMES.USER_REGISTER_SUCCESS,
        })

        this.vuePhone.phone = ""
        this.form = { "platform": "web" }
        if (this.referUser != null && this.referUser !== "" && this.referralCode) {
          this.form.referral_code = this.referralCode
        }
        const query = this.$route.query.redirect ? { redirect: this.$route.query.redirect } : {};

        await this.$router.push({ name: "registrationComplete", query })
      }
    },
    async getReferralInviter() {
      if (this.referralCode != null) {
        const res = await commonService.getReferralInviter(this.referralCode)
        if (res.name) {
          this.referUser = res.name
          this.refereeBonusPercent = res.referee_bonus_percent
          this.propertyImages = res.owned_images.length ? res.owned_images : res.images
          this.ownedProperties = !!res.owned_images.length
          this.form.referral_code = this.referralCode
        }
      }
    },

    getUrlImage(image) {
      return urlImage(image)
    },

    openTC() {
      const url = this.$router.resolve({ name: "termsAndConditions" }).href
      window.open(url, "_blank")
    },

    openPrivacyPolicy() {
      const url = this.$router.resolve({ name: "privacyPolicy" }).href
      window.open(url, "_blank")
    },

    getTCStyle(meta) {
      const state = this.getValidationState(meta)
      return { color: state != null ? state ? '#28a745' : '#dc3545' : '#005151' }
    },

    getPasswordIconStyle(valid) {
      if (this.form.password) {
        if (valid) {
          return { color: '#28a745' };
        }
        return { color: '#dc3545' };
      }
      return { color: '#707a8a' };
    },
    getPasswordIcon(valid) {
      if (this.form.password) {
        if (!valid) {
          return 'x';
        }
      }
      return 'check';
    },
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        { property: "og:title", content: this.title },
        { property: "og:site_name", content: this.title },
      ],
    }
  },

  computed: {
    isReverseOtp () {
      return this.isReverseOtpStep1 || this.isReverseOtpStep2
    },
    isOtpTypeWaba() {
      if (store.state.configs && store.state.configs.otp_type) {
        return store.state.configs.otp_type === OTP_TYPE.RADIST || store.state.configs.otp_type === OTP_TYPE.TWILIO
      }
      return false
    },
    isRegisterWithFacebook() {
      return this.form.hasOwnProperty("fb_id") && this.form.fb_id
        && this.form.hasOwnProperty("fb_token") && this.form.fb_token
        && this.form.hasOwnProperty("email_fb") && this.form.email_fb
    },
    isRegisterWithGoogle() {
      return this.form.hasOwnProperty("google_id") && this.form.google_id
        && this.form.hasOwnProperty("google_token") && this.form.google_token
        && this.form.hasOwnProperty("email_google") && this.form.email_google
    },
    isRegisterWithApple() {
      return this.form.hasOwnProperty("apple_id") && this.form.apple_id
        && this.form.hasOwnProperty("apple_token") && this.form.apple_token
        && this.form.hasOwnProperty("email_apple") && this.form.email_apple
    },
    isRegisterWithSocmed() {
      return this.isRegisterWithFacebook || this.isRegisterWithGoogle || this.isRegisterWithApple
    },
    referralCode() {
      const savedReferralCode = localStorage.getItem('referral_code')
      const codeParam = this.$route.query.code
      if (codeParam && codeParam !== savedReferralCode) {
        localStorage.setItem('referral_code', codeParam)
      }
      return codeParam || savedReferralCode
    },
    disabledReferralInput() {
      return this.referUser != null && this.referUser !== ""
    },
    resendOtpText () {
      if (this.resendOtpTimer > 0) {
        const minutes = Math.floor(this.resendOtpTimer / 60).toString().padStart(2, '0');
        const seconds = (this.resendOtpTimer % 60).toString().padStart(2, '0');
        return this.$t("AUTH.OTP_RESEND_AFTER") + " " + `${minutes}:${seconds}`;
      }
      return this.$t("AUTH.OTP_RESEND")
    },
    needHelpText () {
      let whatsapp = externalSites.WHATSAPP_SUPPORTS['id']
      if (this.userPaymentMethodStripe) {
        whatsapp = externalSites.WHATSAPP_SUPPORTS['en-UK']
      }
      return `${this.$t('AUTH.NEED_HELP_HERE', { whatsapp })}`
    },
    otpStatusText () {
      if (this.inputOtpStatus === OTP_STATUS.DELIVERED) {
        return "Sent"
      }
      return this.inputOtpStatus
    },
    otpStatusClass() {
      return {
        'otp-status-queued': this.inputOtpStatus === OTP_STATUS.QUEUED,
        'otp-status-sent': this.inputOtpStatus === OTP_STATUS.DELIVERED,
        "otp-status-error": this.inputOtpStatus === OTP_STATUS.ERROR,
      };
    },
    otpResendClass() {
      return {
        "hyperlink": this.resendOtpTimer === 0,
        "hyperlink-disabled": this.resendOtpTimer > 0,
      }
    },
    passwordLeast8Length() {
      let isValid = /^(?=.*[^\s]).{8,}$/.test(this.form.password)
      return this.form.password && isValid
    },
    passwordLeast1Number() {
      let isValid = /\d/.test(this.form.password)
      return this.form.password && isValid
    },
    passwordLeast1Upper1LowerCase() {
      let isValid = /^(?=.*[a-z])(?=.*[A-Z]).+$/.test(this.form.password)
      return this.form.password && isValid
    },
    passwordLeast1Special() {
      const regex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
      // Test if the password contains at least one special character
      return regex.test(this.form.password)
    },
    isIndonesian() {
      if (this.$store.getters.userProfile) {
        return this.$store.getters.userProfile.iso_country_code === INDO.ISO_COUNTRY_CODE
      } else if (this.$store.getters.geoLocation) {
        return this.$store.getters.geoLocation.country_code === INDO.COUNTRY_CODE
          || this.$store.getters.geoLocation.iso_country_code === INDO.ISO_COUNTRY_CODE
      }
      return false
    },
    isEnableReferralTokenForReferee() {
      return store.state.configs.enable_referral_token_for_referee;
    },
    referralTokenAmountForReferee() {
      return store.state.configs.referral_token_amount_for_referee;
    },
    referralTokenMinimumPurchaseForReferee() {
      return store.state.configs.referral_token_minimum_purchase;
    },
    referralBonusIndoRefereePercent() {
      if (this.refereeBonusPercent) {
        return this.refereeBonusPercent
      } else if (store.state.configs && store.state.configs.referral_bonus_non_indo_referee_percent) {
        return store.state.configs.referral_bonus_non_indo_referee_percent
      }
      return 0
    },
    referBonusText() {
      if (this.isIndonesian && this.isEnableReferralTokenForReferee && this.referralTokenAmountForReferee) {
        const pricePerToken = 10000;
        return this.$t("REFERRAL.REFERRAL_OWN_PROPERTIES_FREE_TOKEN", {
          token_bonus: this.referralTokenAmountForReferee,
          token_label: this.referralTokenAmountForReferee > 1 ? this.$t('common.TOKENS').toLowerCase() : this.$t('common.TOKEN').toLowerCase(),
          token_value: exchange(this.referralTokenAmountForReferee * pricePerToken, 100, false, "IDR"),
        })
      } else {
        return this.$t("REFERRAL.REFERRAL_OWN_PROPERTIES_CASHBACK", { cashback_percent: `${this.referralBonusIndoRefereePercent}%` })
      }
    },
    referBonusRequiredText() {
      if (this.isIndonesian && this.isEnableReferralTokenForReferee && this.referralTokenAmountForReferee && this.referralTokenMinimumPurchaseForReferee) {
        return this.$t("REFERRAL.REFERRAL_OWN_PROPERTIES_FREE_TOKEN_REQUIRED", {
          token_minimum_required: this.referralTokenMinimumPurchaseForReferee,
          token_label: this.referralTokenMinimumPurchaseForReferee > 1 ? this.$t('common.TOKENS').toLowerCase() : this.$t('common.TOKEN').toLowerCase()
        })
      } else {
        return ""
      }
    },
  },

  watch: {
    resendOtpTimer(value) {
      if (value > 0) {
        setTimeout(() => { this.resendOtpTimer-- }, 1000)
      }
    },

    '$i18n.locale'(newVal, oldVal) {
      setLocale(newVal)
    },
  }
}
</script>
<style lang="scss">
.register {
  margin-top: -20px;
  padding-bottom: 50px;
  background-color: white;

  .logo {
    width: 90px;
    height: 90px;
  }

  h2 {
    margin-top: 20px;
    margin-bottom: 10px;
    color: var(--primary-color);
    font-weight: 600;
    font-size: 32px;
  }

  .form {
    background-color: white;
    box-shadow: 0 8px 35px rgba(7, 55, 99, 0.16);
    border-radius: 28px;
    padding: 30px 30px !important;
  }

  .invalid {
    width: 100%;
    margin-top: .25rem;
    margin-bottom: 0;
    font-size: 80%;
    color: #dc3545
  }

  p {
    color: #6C757D;
    font-weight: 400;
    font-size: 16px;
  }

  hr {
    margin-top: 18px;
    margin-bottom: 18px;
    height: 2px;
    color: #E6EBEF;
    solid-color: #E6EBEF;
  }

  //b-form-group label
  legend {
    padding-top: 5px !important;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    color: var(--primary-darker-color);
  }

  //b-form-input
  input {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    color: var(--primary-darker-color);

    &::placeholder {
      color: #ABB5BE !important;
      opacity: 1;
    }
  }

  //b-form-invalid-feedback
  .invalid-feedback {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
  }

  .show-hide {
    width: 40px;
    background-color: rgba(0, 102, 102, 0.9);
    ;
    cursor: pointer;
    border-radius: 0 4px 4px 0;
    transition: .5s;

    &:hover {
      background-color: rgba(0, 102, 102, 1);
      ;
    }
  }

  .property-image {
    width: 150px;
    height: 150px;
    object-fit: cover;
    margin-left: 10px;
    margin-top: 10px;
    border: 1px solid rgb(219, 219, 219);
    border-radius: 10px;

    @media screen and (max-width: 992px) {
      width: 100px;
      height: 100px;
    }

    @media screen and (max-width: 768px) {
      width: 70px;
      height: 70px;
    }
  }

  .prompt {
    margin-top: 10px;
    font-size: 14px;
    color: #dc3545;
  }

  .suggestion {
    color: #1E90FF;
    text-decoration: underline;
    cursor: pointer;
  }

  .name-note {
    font-size: 14px;
    color: rgb(255, 166, 0);
  }

  .reverse-otp-form {
    width: 100%;
    max-width: 644px;
  }

  .reverse-otp-warning {
    background-color: #FFEFB9;
    //border: 1px solid #ffd680;
    border-radius: 8px;
  }

  .reverse-otp-warning a {
    color: #1E90FF;
    text-decoration: underline;
  }
}
</style>
